import { useState } from "react";
import { NavLink, useParams } from "react-router-dom";
import { CATEGORIES, COLORS } from "../data/catalog";
import { ProductCard } from "../components/site/ProductCard";
import { QuickView } from "../components/site/QuickView";
import { FadeUp, MaskLines } from "../components/site/Reveal";

const TABS = [["all", "/shop"], ["belt-bags", "/shop/belt-bags"], ["crossbody-bags", "/shop/crossbody-bags"], ["new-arrivals", "/shop/new-arrivals"]];

export default function Shop() {
  const { category = "all" } = useParams();
  const cat = CATEGORIES[category] ?? CATEGORIES.all;
  const [filter, setFilter] = useState([]);
  const [qv, setQv] = useState(null);
  const list = filter.length ? COLORS.filter((c) => filter.includes(c.id)) : COLORS;
  const toggle = (id) => setFilter((f) => (f.includes(id) ? f.filter((x) => x !== id) : [...f, id]));

  return (
    <div className="bg-ivory pb-24 pt-36 md:pt-44" data-testid="shop-page">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <p className="label-mono">Collection · {list.length} styles</p>
        <MaskLines key={category} as="h1" lines={[cat.title]} className="mt-3 font-display text-5xl font-light leading-none text-ink md:text-8xl" />
        <p className="mt-4 max-w-md text-sm text-graphite" data-testid="shop-lead">{cat.lead}</p>

        <div className="mt-10 flex flex-col gap-5 border-y border-line py-5 lg:flex-row lg:items-center lg:justify-between">
          <nav className="flex gap-2 overflow-x-auto" aria-label="Categories">
            {TABS.map(([k, to]) => (
              <NavLink key={k} to={to} end data-testid={`shop-tab-${k}`}
                className={({ isActive }) => `whitespace-nowrap border px-4 py-2 text-[11px] uppercase tracking-[0.2em] transition-colors ${isActive ? "border-ink bg-ink text-ivory" : "border-line text-ink hover:border-ink"}`}>
                {CATEGORIES[k].title}
              </NavLink>
            ))}
          </nav>
          <div className="flex flex-wrap items-center gap-2">
            <span className="mr-1 font-mono text-[11px] uppercase tracking-[0.2em] text-graphite">Color</span>
            {COLORS.map((c) => (
              <button key={c.id} onClick={() => toggle(c.id)} data-testid={`shop-filter-${c.id}`} aria-pressed={filter.includes(c.id)}
                className={`flex items-center gap-2 border px-3 py-1.5 text-xs transition-colors ${filter.includes(c.id) ? "border-ink" : "border-line hover:border-graphite"}`}>
                <span className="h-3 w-3 rounded-full ring-1 ring-black/10" style={{ background: c.hex }} />{c.name}
              </button>
            ))}
            {filter.length > 0 && <button onClick={() => setFilter([])} data-testid="shop-filter-clear" className="link-line ml-2 text-xs text-ink">Clear</button>}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 gap-x-3 gap-y-12 md:gap-x-6 lg:grid-cols-3" data-testid="shop-grid">
          {list.map((c, i) => (
            <FadeUp key={c.id} delay={(i % 3) * 0.06}><ProductCard colorId={c.id} onQuickView={setQv} prefix="shop" /></FadeUp>
          ))}
        </div>
        <p className="mt-16 text-center text-xs text-graphite">Every MARKHOR bag can be worn as a belt bag or a crossbody — that's why it appears in both categories.</p>
      </div>
      <QuickView colorId={qv} onClose={() => setQv(null)} />
    </div>
  );
}
